import React, { useState } from "react";
import { Link } from "react-router-dom";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Helmet } from "react-helmet";

export const Header = (props) => {
  const [showAlert, setShowAlert] = useState(true);

  return (
    <>
      {/*
      {showAlert && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            animation: "fadeIn 0.5s ease-in-out",
            padding: "40px", // Añade algo de espacio en pantallas pequeñas
          }}
        >
          <div
            style={{
              backgroundColor: "#fff8e1",
              color: "#5d4037",
              padding: "50px 60px",
              borderRadius: "16px",
              maxWidth: "800px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
              position: "relative",
              textAlign: "center",
              fontFamily: "'Poppins', sans-serif",
              animation: "slideDown 0.5s ease-out",
            }}
          >
            <WarningAmberIcon style={{ fontSize: "50px", color: "#ff9800" }} />
            <h2 style={{ margin: "15px 0", fontWeight: "600" }}>
              Anuncio Importante
            </h2>

            <p
              style={{
                fontSize: "17px",
                marginBottom: "25px",
                lineHeight: "1.8",
                textAlign: "justify",
              }}
            >
              Nuestras tarifas están en dólares americanos y todos los pagos
              deben realizarse en esta moneda. Aceptamos transferencias o
              depósitos a nuestras cuentas corrientes, así como pagos en línea
              con tarjeta de crédito, con una comisión del 5% adicional al monto
              total.
            </p>

           
            <img
              src="/img/airbox/airbox_modal.png"
              alt="Logo"
              style={{ width: "100px", marginTop: "20px" }}
            />

            <button
              onClick={() => setShowAlert(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                background: "none",
                border: "none",
                fontSize: "26px",
                color: "#5d4037",
                cursor: "pointer",
              }}
              aria-label="Cerrar"
            >
              ×
            </button>
          </div>
        </div>
      )}
            */}
      <header id="header">
      <Helmet>
        <title>ABX Shipping - Inicio</title>
      </Helmet>
        <div className="intro">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 intro-text">
                  <h1>
                    {props.data ? props.data.title : "Loading"}
                    <span></span>
                  </h1>
                  <p>{props.data ? props.data.paragraph : "Loading"}</p>
                  <Link to="/about" className="btn btn-custom btn-lg">
                    Descubre Más
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
